// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
  background-color: #e5e5e5;
  display: flex;
  justify-content: space-between;
}
.left{
  margin-top: 30px;
  margin-bottom: 30px;
}
.right{
  margin-top: 30px;
  margin-bottom: 30px;
}
.kc-div {
  /* text-align: left; */
  margin-left: 90px;
  font-weight: 700;
  font-size: 20px;
  line-height: 160%;
  color: #12394d;
  align-items: center;
  font-family: Roboto;
}

.address-div {
  margin-left: 90px;
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #666666;
}

.red-link {
  color: #cc0000;
  font-weight: 700;
  text-decoration: none;
}

.social-media-div {
  text-align: right;
}

.social-media-icon {
  margin: 15px;
  color: #cc0000;
  font-size: 2em;
}

.copyright-div {
  margin-top: 60px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}



@media (max-width: 700px){
  .footer{
    display: flex;
    flex-direction: column;
  }
  .kc-div{
    margin-left: 30px
  }
  .address-div{
    margin-left: 30px;
  }
  .social-media-div{
    text-align: left;
    margin-top: 15px;
    margin-left: 15px;
  }
  .social-media-icon{
    font-size: 2em;
  }
  .copyright-div{
    margin-top: 20px;
    margin-left: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;;;AAIA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE;EACF;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".footer{\n  background-color: #e5e5e5;\n  display: flex;\n  justify-content: space-between;\n}\n.left{\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.right{\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.kc-div {\n  /* text-align: left; */\n  margin-left: 90px;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 160%;\n  color: #12394d;\n  align-items: center;\n  font-family: Roboto;\n}\n\n.address-div {\n  margin-left: 90px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: #666666;\n}\n\n.red-link {\n  color: #cc0000;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.social-media-div {\n  text-align: right;\n}\n\n.social-media-icon {\n  margin: 15px;\n  color: #cc0000;\n  font-size: 2em;\n}\n\n.copyright-div {\n  margin-top: 60px;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #666666;\n}\n\n\n\n@media (max-width: 700px){\n  .footer{\n    display: flex;\n    flex-direction: column;\n  }\n  .kc-div{\n    margin-left: 30px\n  }\n  .address-div{\n    margin-left: 30px;\n  }\n  .social-media-div{\n    text-align: left;\n    margin-top: 15px;\n    margin-left: 15px;\n  }\n  .social-media-icon{\n    font-size: 2em;\n  }\n  .copyright-div{\n    margin-top: 20px;\n    margin-left: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
